import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { deductionData, taskSchemaObject } from '../taskSchema'
import { Fields, validateProperty, validate, Card } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { PageHeader } from '../../../Common';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import { functions } from 'lodash';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'TASKCATEGORY';

export function TaskCategoryAddEdit(props) {

    const { data, edit } = props.location
    const [title, setTitle] = useState("Add Task Category")
    const [groups, setGroups] = useState()
    const [estates, setEstates] = useState()
    const [taskType, setTaskType] = useState();
    const [task, setTask] = useState({
        estateTaskId: "0",
        groupID: "0",
        operationEntityID: "0",
        taskTypeID: "0",
        estateTaskName: " ",
        estateTaskDescription: " ",
        isActive: true
    });
    const [buttonName, setButtonName] = useState("Save");
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })

    const [pageProperties, setPageProperties] = useState({
        title: 'Add Task',
        submitButtonName: 'Save',
        passwordFieldDisabled: false
    })

    const schema = Joi.object(taskSchemaObject).options({ allowUnknown: true })

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getEstates()
        )
    }, [task.groupID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITTASKCATEGORY');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        if (data && edit) {
            setTitle("Edit Task Category");
            setTask(data);
            setButtonName("Update");
        } else {
            setTitle("Add Task Category");
            var token = tokenService.getUserDetailsFromToken();
            setTask({
                ...task,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }
        trackPromise(
            getAllGroups(),
            getTaskTypes()
        )
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setTask({
            ...task,
            groupID: target.value,
            operationEntityID: '0'
        })
    }

    function handleOperationEntityChange(target) {
        validateInputs(target);

        setTask({
            ...task,
            operationEntityID: target.value
        })
    }

    function handleTaskNameChange(target) {
        validateInputs(target);

        setTask({
            ...task,
            estateTaskName: target.value
        })
    }

    function handleTaskDescriptionChange(target) {
        validateInputs(target);

        setTask({
            ...task,
            estateTaskDescription: target.value
        })
    }

    function handleActiveChange(target) {
        validateInputs(target);

        setTask({
            ...task,
            isActive: target.checked
        })
    }
    function handleTaskTypeChange(target) {
        validateInputs(target);

        setTask({
            ...task,
            taskTypeID: target.value
        })
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, taskSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error)


    }

    async function handleSave(e) {
        e.preventDefault()

        const errorMessages = validate(schema, task)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return

        saveEdit();

    }
    async function saveEdit() {
        if (!edit) {

            const response = await services.saveTask(task);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
        if (edit) {

            const response = await services.editTask(task);
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function afterSuccessfulyChanged(response, factoryItems) {

        if (response === "Success") {

            setTimeout(() => {
                props.history.push({ pathname: '/taskCategory' })
            }, 1500);
        }
    }

    async function getEstates() {
        const result = await services.GetAllOperationEntityByGroupID(task.groupID)
        setEstates(result)
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }
    async function getTaskTypes() {
        const result = await services.getTaskTypes(task)
        setTaskType(result)
    }

    function generateDropDownMenu(data) {

        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function clearButton() {

        setTask({
            ...task,
            estateTaskId: '',
            groupID: 0,
            operationEntityID: 0,
            taskTypeID: 0,
            estateTaskName: '',
            estateTaskDescription: '',
            isActive: true
        });
        setErrors({});

    }
    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    buttonText="Back to Listing"
                                    path="/taskCategory"

                                />
                            </div>
                            <hr />
                            <form onSubmit={(e) => handleSave(e)}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            name="groupID"
                                            value={task.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={task.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="taskTypeID">Task Type *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="taskTypeID"
                                            name="taskTypeID"
                                            value={task.taskTypeID}
                                            onChange={(e) => handleTaskTypeChange(e.target)}>
                                            <MenuItem value="0">--Select Task Type--</MenuItem>
                                            {generateDropDownMenu(taskType)}
                                        </Select>
                                        {errors["taskTypeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["taskTypeID"]}</FormHelperText>}
                                    </div>

                                </div>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateTaskName">Task Category Name *</InputLabel>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            name="estateTaskName"
                                            id="estateTaskName"
                                            onChange={(e) => handleTaskNameChange(e.target)}
                                            value={task.estateTaskName}
                                        />
                                        {errors["estateTaskName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["estateTaskName"]}</FormHelperText>}

                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateTaskDescription">Task Category Description *</InputLabel>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            name="estateTaskDescription"
                                            id="estateTaskDescription"
                                            onChange={(e) => handleTaskDescriptionChange(e.target)}
                                            value={task.estateTaskDescription}
                                        />
                                        {errors["estateTaskDescription"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["estateTaskDescription"]}</FormHelperText>}

                                    </div>
                                </div>
                                <label htmlFor="switch1" >Active</label>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <input
                                            className="mr-2"
                                            id="isActive"
                                            switch="none"
                                            type="checkbox"
                                            name="isActive"
                                            onChange={(e) => handleActiveChange(e.target)}
                                            checked={task.isActive}
                                        />
                                        <label htmlFor="isActive" data-on-label="Yes"
                                            data-off-label="No"></label>
                                    </div>
                                </div>


                                <MessageModal
                                    hidden={messageModel.hidden}
                                    messageType={messageModel.type}
                                    messageDescription={messageModel.disciption}
                                    clicked={modalDismissHandler}
                                />

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, task)}
                                        type="submit"
                                        className="btn btn-primary"
                                        value={buttonName}
                                        onClick={handleSave}
                                    />
                                    <input
                                        type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={clearButton}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}